module.exports = __webpack_public_path__ + "static/media/earth.ec9c38de.svg";